import { useState } from "react";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useStore } from "@/store/StoreContext";

export default function NotifyForm({ product }) {
  const { user } = useStore();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const target = user ? user.email : email;
    if (!target) return;
    setBusy(true);
    try {
      await api.post("/restock-alerts", { email: target, slug: product.slug, phone: phone || undefined });
      setDone(true);
      toast.success("You're on the list.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="border border-gold/40 bg-gold/5 p-5" data-testid="notify-success">
        <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold flex items-center gap-2">
          <Bell size={13} /> Alert Armed
        </p>
        <p className="text-xs text-cream/50 mt-2">
          The moment this piece returns, an email lands in your inbox. Move fast when it does.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-white/15 p-5" data-testid="notify-form">
      <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-cream/70 flex items-center gap-2 mb-4">
        <Bell size={13} className="text-gold" />
        {product.status === "sold_out" ? "Restock Alert" : "Release Alert"}
      </p>
      {user ? (
        <button
          type="submit"
          disabled={busy}
          className="w-full border border-gold/60 text-gold font-mono2 text-[10px] tracking-[0.25em] uppercase py-3.5 hover:bg-gold hover:text-noir-bg transition-colors duration-300 disabled:opacity-50"
          data-testid="notify-submit-button"
        >
          {busy ? "Arming…" : `Notify Me — ${user.email}`}
        </button>
      ) : (
        <div>
          <div className="flex">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="flex-1 bg-transparent border border-white/15 border-r-0 px-4 py-3 text-sm placeholder:text-cream/30 focus:outline-none focus:border-gold/60 transition-colors"
              data-testid="notify-email-input"
            />
            <button
              type="submit"
              disabled={busy}
              className="bg-gold text-noir-bg px-5 font-mono2 text-[10px] tracking-[0.2em] uppercase hover:bg-cream transition-colors duration-300 disabled:opacity-50"
              data-testid="notify-submit-button"
            >
              {busy ? "…" : "Notify Me"}
            </button>
          </div>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone for SMS alerts — optional (+1…)"
            className="w-full mt-2 bg-transparent border border-white/15 px-4 py-3 text-sm placeholder:text-cream/30 focus:outline-none focus:border-gold/60 transition-colors"
            data-testid="notify-phone-input"
          />
        </div>
      )}
    </form>
  );
}
